window.addEventListener('load', () => {
    let supportsAudio = !!document.createElement('audio').canPlayType;
    let audioPanels = document.querySelectorAll('.audio-panel');

    for (let panel of audioPanels) {
        let playerTarget = panel.querySelector('audio')

        if (supportsAudio) {
            // initialize playlist and controls
            let index = 0,
                playing = false,
                trackSelector = panel.querySelectorAll('[data-track]'),
                tracks = [];

            for (let track of trackSelector) {
                tracks.push({
                    'track': track.querySelector('[data-number]').dataset.number,
                    'name': track.querySelector('[data-name]').dataset.name,
                    'duration': track.querySelector('[data-duration]').dataset.duration,
                    'file': track.dataset.location,
                });
            }

            let trackCount = tracks.length;
            let currentTitle = panel.querySelector('[data-name-current]');

            playerTarget.addEventListener('play', () => {
                playing = true;
            });

            playerTarget.addEventListener('pause', () => {
                playing = false;
            });

            playerTarget.addEventListener('ended', () => {
                if ((index + 1) < trackCount) {
                    index++;
                    loadTrack(index);
                    playerTarget.play();
                } else {
                    playerTarget.pause();
                    index = 0;
                    loadTrack(index);
                }
            });

            for (let item of trackSelector) {
                item.addEventListener('click', () => {
                    let id = parseInt(item.querySelector('[data-number]').dataset.number,);
                    if (id !== index) {
                        playTrack(id);
                    }
                });
            }

            let loadTrack = function (id) {
                    currentTitle.innerText = tracks[id].name;
                    index = id;
                    playerTarget.src = tracks[id].file;
                };

            let playTrack = function (id) {
                    loadTrack(id);
                    playerTarget.play();
                };

            loadTrack(index);
        }
    }

});
